import styled from "styled-components";
import { PREMIUM_PADDING } from "theme/interpolations/padding";

import { useTwoFAContext } from "Login/TwoFA/TwoFA";

import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import NetworkDisplay from "./NetworkDisplay";
import WelcomeMessage from "./WelcomeMessage";

const SFnrVerticalGap = styled(FnrVerticalGap)`
  padding-bottom: ${PREMIUM_PADDING}px;
`;

const Header = () => {
  const { showNetwork, headerText } = useTwoFAContext();

  if (showNetwork === false && headerText === false) return null;

  return (
    <SFnrVerticalGap data-cy="TwoFA_Header" gap={0}>
      <NetworkDisplay />
      <WelcomeMessage />
    </SFnrVerticalGap>
  );
};

export default Header;
